import {FuseRouteItemType} from '@/@fuse/utils/FuseUtils';
import {AUTH_ROLES} from '@/app/auth';

import DownloadAppPage from './DownloadAppPage';

const DownloadAppRoute: FuseRouteItemType = {
  path: '',
  element: <DownloadAppPage />,
  auth: AUTH_ROLES.user,
  children: [
    {
      path: 'teen/redirection',
      element: <DownloadAppPage />,
    },
  ],
};

export default DownloadAppRoute;
